/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */

// Instancia LiquidCrystal_I2C fija (0x27, 16x2): el campo de pin del bloque es
// decorativo y el generador no lo usa, como el legacy.

const LCD_DECLARE = '\n#include <Wire.h>\n#include <LiquidCrystal_I2C.h>\n\nLiquidCrystal_I2C lcd(0x27, 16, 2);\n';
const LCD_SETUP = '\n  lcd.init();\n  lcd.backlight();\n  lcd.clear();\n';

const declareLcd = (generator) => {
  generator.definitions_['declare_lcd'] = LCD_DECLARE;
  generator.setups_['setup_lcd_'] = LCD_SETUP;
};

export const lcd_educabot = (block, generator) => {
  const col = block.getFieldValue('CURSOR_COLUMN');
  const row = block.getFieldValue('CURSOR_ROW');
  const output = generator.valueToCode(block, 'NAME', generator.ORDER_ATOMIC) || '';

  declareLcd(generator);
  return `\n  lcd.setCursor(${col}, ${row});\n  lcd.print(${output});\n`;
};

export const lcd_setBacklight = (block, generator) => {
  const state = block.getFieldValue('STATE');

  declareLcd(generator);
  return `\n  lcd.setBacklight(${state});\n`;
};

export const lcd_clear = (block, generator) => {
  declareLcd(generator);
  return '\n  lcd.clear();\n';
};
